import { Component, Input } from "@angular/core";
import { FilterModelDto } from "../../models/filter.model";
import { FilterSettingService } from "../../services/filter-setting.service";

@Component({
  selector: "app-period",
  templateUrl: "./period.component.html",
  styleUrls: ["./period.component.scss"],
})
export class PeriodComponent {
  @Input() isStartDate = false;
  @Input() title = "";
  @Input() filterStart!: FilterModelDto;
  @Input() filterEnd!: FilterModelDto;
}
